<template>
  <div class="wrapper wrapper_wide section_header">
    <div class="frame">
      <PictureFrame v-if="!isMobile" :thumbnail="false" :path="'main/pc_top_main_a0'" :repeat="4"/>
      <PictureFrame v-if="!isMobile" :thumbnail="false" :path="'main/pc_top_main_b0'" :repeat="4"/>
      <PictureFrame v-if="isMobile && !isbrowserTabWidth" :thumbnail="false" :path="'main/sp_top_main_0'" :repeat="4"/>
      <PictureFrame v-if="isMobile && isbrowserTabWidth" :thumbnail="false" :path="'main/pc_top_main_a0'" :repeat="4"/>
      <PictureFrame v-if="isMobile && isbrowserTabWidth" :thumbnail="false" :path="'main/pc_top_main_b0'" :repeat="4"/>
      <Marquee/>
      <p class="clinic_concept" v-html="copyTxt"></p>
      <p class="scroll_induction" @click="translate">Scroll</p>
    </div>
  </div>
</template>

<script>
// molcules
import Marquee from '../molcules/marquee.vue'
import PictureFrame from '../molcules/pictureFrame.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'SectionHeader',
  components: {
    Marquee,
    PictureFrame
  },
  props: {
    msg: String
  },
  computed: {
    ...mapState([
      'siteData',
      'isMobile'
    ]),
    copyTxt () {
      return this.siteData.home.header.copy
    },
    isbrowserTabWidth () {
      return window.innerWidth > 415
    }
  },
  methods: {
    ...mapActions([
      'smoothScroll'
    ]),
    translate () {
      const scrollPos = document.querySelector('.section_header + div').offsetTop - (this.isMobile ? document.querySelector('.header').clientHeight : 0)
      this.smoothScroll({
        duration: 100,
        scrollPos: scrollPos
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
